const e = "and", o = "Back", i = "Close", a = "Continue", s = "days", n = "d", t = "Email", r = "Hello", l = "hour", d = "hours", c = "h", u = "minutes", X = "min", h = "none", y = "Optional", p = "people", g = "person", m = "Register", b = "seconds", f = "s", w = "Sending", k = "By clicking on this link, you agree to receive news and promotions from our brand. In compliance with General Data Protection Regulation (GDPR), we are informing you that your data will be incorporated into our database. As a client, you may freely know and access the personal data under our control and exercise your rights as owner of this data in accordance with GDPR.", v = "I accept the Terms & Conditions", T = {
  "(Optional)": "(Optional)",
  "Already registered?": "Already registered?",
  and: e,
  "Apply promocode": "Apply promocode",
  Back: o,
  "Book Now": "Book Now",
  "Call Now": "Call Now",
  "Click here": "Click here",
  Close: i,
  "Close dialog": "Close dialog",
  "Confirm your email": "Confirm your email",
  "Contact Now": "Contact Now",
  Continue: a,
  days: s,
  days_abbr: n,
  Email: t,
  "Enter the validation code sent to your email": "Enter the validation code sent to your email",
  "Exclusive benefits unlocked!": "Exclusive benefits unlocked!",
  "Great! Email successfully sent!": "Great! Email successfully sent!",
  Hello: r,
  hour: l,
  hours: d,
  hours_abbr: c,
  "I agree to the": "I agree to the",
  "Invalid code": "Invalid code",
  "Last reservation was XXXXXX hours ago": "Last reservation was XXXXXX hours ago",
  "Loyalty Login": "Loyalty Login",
  "Loyalty Login's default Terms & Conditions": "Loyalty Login's default Terms & Conditions",
  minutes: u,
  minutes_abbr: X,
  none: h,
  "Not registered yet?": "Not registered yet?",
  "Not registered?": "Not registered?",
  "Only for registered users": "Only for registered users",
  "Only for specific rates": "Only for specific rates",
  Optional: y,
  people: p,
  "Perk 1 will be listed here": "Perk 1 will be listed here",
  "Perk 2 will be listed here": "Perk 2 will be listed here",
  "Perk 3 will be listed here": "Perk 3 will be listed here",
  person: g,
  "Please, provide a valid e-mail": "Please, provide a valid e-mail",
  "Privacy policy": "Privacy policy",
  Register: m,
  "Resend code": "Resend code",
  seconds: b,
  seconds_abbr: f,
  "Send to booking engine": "Send to booking engine",
  Sending: w,
  "Sending search": "Sending search",
  "Sign in": "Sign in",
  "Sign in to your account": "Sign in to your account",
  "Something went wrong. Please, try again later.": "Something went wrong. Please, try again later.",
  "Subject to availability": "Subject to availability",
  "Terms and conditions": "Terms and conditions",
  Terms_default: k,
  Terms_default_label: v,
  "Thank you!": "Thank you!",
  "There are XXXXXX people looking at this hotel right now": "There are XXXXXX people looking at this hotel right now",
  "There has been an error.": "There has been an error.",
  "This conversation will be recorded for quality and training purposes.": "This conversation will be recorded for quality and training purposes.",
  "This is a standard paragraph, use it to display information.": "This is a standard paragraph, use it to display information.",
  'This is paragraph. <b>Bold</b> it, <i>italicise</i> it, <u>underline</u> it, add <a href="#">links</a>, emojis 🙂, and more!': 'This is paragraph. <b>Bold</b> it, <i>italicise</i> it, <u>underline</u> it, add <a href="#">links</a>, emojis 🙂, and more!',
  "Title of your message": "Title of your message",
  "Today's special offer: XXXXXX": "Today's special offer: XXXXXX",
  "View all XXXXXX perks": "View all XXXXXX perks",
  "We have received your form submission correctly": "We have received your form submission correctly.",
  "We will send you an email with your search very soon.": "We will send you an email with your search very soon.",
  "Web exclusive": "Web exclusive",
  "XXXXXX people have already booked today": "XXXXXX people have already booked today",
  "XXXXXX people have looked at this hotel today": "XXXXXX people have looked at this hotel today",
  "XXXXXX% discount only today": "XXXXXX% discount only today",
  "You must agree to the Terms & Conditions first": "You must agree to the Terms & Conditions first",
  "Your email": "Email",
  "Your email address has been successfully added to our list.": "Your email address has been successfully added to our list."
};
export {
  o as Back,
  i as Close,
  a as Continue,
  t as Email,
  r as Hello,
  y as Optional,
  m as Register,
  w as Sending,
  k as Terms_default,
  v as Terms_default_label,
  e as and,
  s as days,
  n as days_abbr,
  T as default,
  l as hour,
  d as hours,
  c as hours_abbr,
  u as minutes,
  X as minutes_abbr,
  h as none,
  p as people,
  g as person,
  b as seconds,
  f as seconds_abbr
};
//# sourceMappingURL=en.fNPZPFmZ.js.map
